export const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    padding: "0",
    position: "relative",
    borderRadius: "5px",
    overflow: "hidden",
    lineHeight: "25px",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.6)",
    zIndex: "9999",
  },
};
